module.exports = __webpack_public_path__ + "static/media/pride_group.533e2b58.jpg";